import React from "react";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";


export default function InspectionRow({data, index, onChange}){


    return (
        <tr>
            <td>{data.inspection_type}</td>
            <td>
                {useEditableTableDateCell({
                    propName: "expiry_date",
                    value: data.expiry_date,
                    onChange: (e) => onChange(e, index),
                    editable: true,
                    inlineEdit: false,
                    disabled: !!data.booked_in_date
                })}
            </td>
        </tr>
    )

}